<template>
  <!-- 自定义人群 -->
  <crowd-pack v-if="formKey === 'crowd_pack'" :config-data="formItem" :advertiser-id="advertiserId" />

  <!-- 手机价格 -->
  <div v-else-if="formItem.type === 'slider'">
    <el-slider
      v-model="formItem.value"
      range
      :marks="formItem.options"
      style="padding: 20px"
      v-bind="formItem.props"
      v-on="formItem.on"
    />
    <div class="chose-price">
      <span>快捷设置</span>
      <el-button @click="formItem.quickSetting([2000,4000])">2000元 - 4000元</el-button>
      <el-button @click="formItem.quickSetting([4000,6000])">4000元 - 6000元</el-button>
      <el-button @click="formItem.quickSetting([6000,8000])">6000元 - 8000元</el-button>
      <el-button @click="formItem.quickSetting([8000,11000])">8000元以上</el-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    'crowd-pack': () => import('./crowd-pack'),
  },
  props: {
    advertiserId: {
      type: [String, Number],
      required: true,
    },
    formItem: {
      type: Object,
      required: true,
    },
    formKey: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.chose-price {
  margin-top: 50px;
  button {
    color: #1890ff;
    border:  none;
  }
}
</style>
